const settings = require('../../../../../js-handler/settings')
const validator = require('../../../../../components/textfield/validator.min')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const fullcontTab = require('../../../../../components/fullcont/fullcont-form-handler-tab')
const snack = require('../../../../../components/snack/snack')

export function purchaseSendEmail(detail, htmlFc) {
  let check = htmlFc.fullcontHTML.querySelector("#purchase_send_email input");
  let mail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input").value;
  let elem = document.querySelector("#purchase-fullcont");
  let dbid = elem.getAttribute("data-dbid");

  if (check.checked && mail && validator.isEmail(mail)) {
    pdfGeneratorPurchase(dbid);
  }
}

function pdfGeneratorPurchase(dbid) {
  if (!dbid) return;

  const formData = new FormData();
  formData.append('purchase_id', dbid);

  fetch(`./server/php/queries/report/purchase/pdf-invoice.php`, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin'
  })
    .then(res => res.json())
    .then(result => {

      console.log(result);

      if (result.file_path != "" && result.print === "true") {
        const iframe = document.querySelector("#reportIframe");
        iframe.src = result.file_path;
        setTimeout(() => iframe.contentWindow.print(), 200);
      }

      if (result.check_mail === "true") {
        sendInvoicePurchase(result.file_path, result.name, result.code, dbid);
      }

    })
    .catch(err => {
      console.error(err)
    });
}

export function sendInvoicePurchase(pathpdf, name, code, dbid) {
  let input_email = document.querySelector('#purchase_form_email input');
  let userId = settings.getData().id;

  sendmail({
    email: input_email.value,
    type: "sendinvoice",
    pathpdf: pathpdf,
    dbid: dbid,
    userId: userId,
    entity: 'purchase',
    name: name,
    code: code
  });
}


function sendmail(data) {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));

  const controller = new AbortController();
  setTimeout(() => controller.abort(), 30000);

  snack.start({ act: 'show', id: 'sendemail' });

  fetch(`./server/php/send-emails/sendEmail.php`, {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  })
    .then(res => res.json())
    .then(result => {
      if (result.code === 400) {
        alert("An error occurred while sending the email. Recharge");
      }
    })
    .catch(err => {
      throw err;
    });
}

// ya no se usa esta funcion
export function purchaseTrackingMail(detail, htmlFc) {
  let check = htmlFc.fullcontHTML.querySelector("#purchase_send_email");
  let check_value = check.querySelector("input[type='checkbox']").checked;
  let mail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input").value;
  let provider_id = "";
  let elem = document.querySelector("#purchase-fullcont");
  let dbid = elem.getAttribute("data-dbid");
  let userId = "";
  userId = settings.getData().id

  htmlFc.form.forEach((a) => {
    if (a.name == 'provider_id') {
      provider_id = a.value;
    }
  })

  if (check_value && (mail != "" && validator.isEmail(mail))) {
    trackingEmail({ purcahse_id: dbid, email: mail, provider: provider_id, entity: "purchase", user: userId });
  }
}

function trackingEmail(data) {
  const formData = new FormData();
  formData.append('purchase_id', data.purcahse_id);
  formData.append('email', data.email);
  formData.append('provider', data.provider);
  formData.append('entit', data.entity);
  formData.append('userId', data.user);
  //console.log(formData);

  const controller = new AbortController();

  // Obtén el purchase_id de alguna manera (puede ser un parámetro o una variable)
  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/queries/tracking/purchase_tracking_email.php`, options)
    .then(result => {
      //console.log(result)
      return result.json();
    })
    .then((result) => {
      if (result.code == 400) {
        alert("An error occurred while sending the email. Recharge");
      }
    })
    .catch((error) => {
      throw error;
      //console.log('result 3', 'ERRORRRRRRRR');
    });
}